/* eslint-disable import/no-cycle */
export default [
  {
    path: '/system-config',
    name: 'SystemConfig',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: 'dictionary-manage',
        name: 'SystemConfigDictionaryManage',
        component: () => import('@/views/system-config/dictionary-manage'),
        meta: {
          title: '字典管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'domain-manage/list',
        name: 'DomainManageList',
        component: () => import('@/views/system-config/domain-manage'),
        meta: {
          title: '域名配置',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'logistics-manage/list',
        name: 'LogisticsManageList',
        component: () => import('@/views/system-config/logistics-manage/index.vue'),
        meta: {
          title: '物流管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'warehouse-manage/list',
        name: 'WarehouseManageList',
        component: () => import('@/views/system-config/warehouse-manage/index.vue'),
        meta: {
          title: '仓库管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'regional-setting/list',
        name: 'RegionalSettingList',
        component: () => import('@/views/system-config/regional-setting/views/list/index.vue'),
        meta: {
          title: '区域设置',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'userquery-manage/list',
        name: 'UserqueryManageList',
        component: () => import('@/views/system-config/userquery-manage/index.vue'),
        meta: {
          title: '百布用户查询',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'agreement-manage/list',
        name: 'SystemConfigAgreementManageList',
        component: () => import('@/views/system-config/agreement-manage/view/list/index.vue'),
        meta: {
          title: '协议CMS',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'agreement-manage/detail',
        name: 'SystemConfigAgreementManageDetail',
        component: () => import('@/views/system-config/agreement-manage/view/detail/index.vue'),
        meta: {
          title: '协议CMS详情',
          noCache: false,
          auth: true,
          activeMenu: 'SystemConfigAgreementManageList',
        },
      },
      {
        path: 'sysparam/list',
        name: 'SysparamManageList',
        component: () => import('@/views/system-config/sysparam-manage/index.vue'),
        meta: {
          title: '系统参数',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
